import { Pet } from "../core/pet";
import { 阿克希亚 } from "./pet/阿克希亚";
import { 厄尔塞拉 } from "./pet/厄尔塞拉";
import { 昊希娜 } from "./pet/昊希娜";
import { 凯洛亚 } from "./pet/凯洛亚";
import { 肯佩德 } from "./pet/肯佩德";
import { 奈尼芬多 } from "./pet/奈尼芬多";
import { 瀚宇星皇 } from "./pet/瀚宇星皇";
import { 重生之翼 } from "./pet/重生之翼";
import { 朱雀 } from "./pet/朱雀";
import { 谱尼 } from "./pet/谱尼";
import { 盖亚 } from "./pet/盖亚";
import { 迪符特 } from "./pet/迪符特";
import { 卡修斯 } from "./pet/卡修斯";
import { 布莱克 } from "./pet/布莱克";

/** 创建一场默认比赛使用的完整精灵池。 */
export const createDefaultDraftPool = (): Pet[] => [
    new 朱雀(
        {
            攻击: 400,
            特攻: 500,
            防御: 400,
            特防: 400,
            速度: 500,
            体力: 950,
        },
        {
            criticalDamage: 0.30,
            fixedDamage: 0.35,
            percentDamage: 0.35,
        },
        [
            { state: "害怕", rate: 0.5 },
            { state: "麻痹", rate: 0.25 },
            { state: "睡眠", rate: 0.25 },
        ],
    ),
    new 奈尼芬多(
        {
            攻击: 400,
            特攻: 600,
            防御: 400,
            特防: 400,
            速度: 500,
            体力: 950,
        },
        {
            criticalDamage: 0.30,
            fixedDamage: 0.35,
            percentDamage: 0.35,
        },
        [
            { state: "害怕", rate: 0.5 },
            { state: "麻痹", rate: 0.25 },
            { state: "睡眠", rate: 0.25 },
        ],
    ),
    new 凯洛亚(
        {
            攻击: 400,
            特攻: 580,
            防御: 450,
            特防: 470,
            速度: 430,
            体力: 910,
        },
        {
            criticalDamage: 0.30,
            fixedDamage: 0.35,
            percentDamage: 0.35,
        },
        [
            { state: "害怕", rate: 0.5 },
            { state: "麻痹", rate: 0.25 },
            { state: "睡眠", rate: 0.25 },
        ],
    ),
    new 厄尔塞拉(
        {
            攻击: 400,
            特攻: 600,
            防御: 400,
            特防: 400,
            速度: 500,
            体力: 950,
        },
        {
            criticalDamage: 0.30,
            fixedDamage: 0.35,
            percentDamage: 0.35,
        },
        [
            { state: "害怕", rate: 0.5 },
            { state: "麻痹", rate: 0.25 },
            { state: "睡眠", rate: 0.25 },
        ],
    ),
    new 盖亚(
        {
            攻击: 700,
            特攻: 400,
            防御: 400,
            特防: 400,
            速度: 500,
            体力: 950,
        },
        {
            criticalDamage: 0.30,
            fixedDamage: 0.35,
            percentDamage: 0.35,
        },
        [
            { state: "害怕", rate: 0.5 },
            { state: "麻痹", rate: 0.25 },
            { state: "睡眠", rate: 0.25 },
        ],
    ),
    new 重生之翼(
        {
            攻击: 580,
            特攻: 580,
            防御: 400,
            特防: 420,
            速度: 480,
            体力: 1110,
        },
        {
            criticalDamage: 0.30,
            fixedDamage: 0.35,
            percentDamage: 0.35,
        },
        [
            { state: "害怕", rate: 0.5 },
            { state: "麻痹", rate: 0.25 },
            { state: "睡眠", rate: 0.25 },
        ],
    ),

    new 谱尼(
        {
            攻击: 400,
            特攻: 500,
            防御: 400,
            特防: 400,
            速度: 500,
            体力: 950,
        },
        {
            criticalDamage: 0.30,
            fixedDamage: 0.35,
            percentDamage: 0.35,
        },
        [
            { state: "害怕", rate: 0.5 },
            { state: "麻痹", rate: 0.25 },
            { state: "睡眠", rate: 0.25 },
        ],
    ),
    new 阿克希亚(
        {
            攻击: 400,
            特攻: 500,
            防御: 400,
            特防: 400,
            速度: 500,
            体力: 950,
        },
        {
            criticalDamage: 0.30,
            fixedDamage: 0.35,
            percentDamage: 0.35,
        },
        [
            { state: "害怕", rate: 0.5 },
            { state: "麻痹", rate: 0.25 },
            { state: "睡眠", rate: 0.25 },
        ],
    ),
    new 肯佩德(
        {
            攻击: 600,
            特攻: 480,
            防御: 450,
            特防: 470,
            速度: 430,
            体力: 975,
        },
        {
            criticalDamage: 0.30,
            fixedDamage: 0.35,
            percentDamage: 0.35,
        },
        [
            { state: "害怕", rate: 0.5 },
            { state: "麻痹", rate: 0.25 },
            { state: "睡眠", rate: 0.25 },
        ],
    ),
    new 昊希娜(
        {
            攻击: 400,
            特攻: 580,
            防御: 450,
            特防: 470,
            速度: 430,
            体力: 910,
        },
        {
            criticalDamage: 0.30,
            fixedDamage: 0.35,
            percentDamage: 0.35,
        },
        [
            { state: "害怕", rate: 0.5 },
            { state: "麻痹", rate: 0.25 },
            { state: "睡眠", rate: 0.25 },
        ],
    ),
    new 瀚宇星皇(
        {
            攻击: 600,
            特攻: 300,
            防御: 400,
            特防: 400,
            速度: 500,
            体力: 1050,
        },
        {
            criticalDamage: 0.30,
            fixedDamage: 0.35,
            percentDamage: 0.35,
        },
        [
            { state: "害怕", rate: 0.5 },
            { state: "麻痹", rate: 0.25 },
            { state: "睡眠", rate: 0.25 },
        ],
    ),
    new 迪符特(
        {
            攻击: 450,
            特攻: 550,
            防御: 400,
            特防: 400,
            速度: 430,
            体力: 870,
        },
        {
            criticalDamage: 0.30,
            fixedDamage: 0.35,
            percentDamage: 0.35,
        },
        [
            { state: "害怕", rate: 0.5 },
            { state: "麻痹", rate: 0.25 },
            { state: "睡眠", rate: 0.25 },
        ],
    ),
    new 卡修斯(
        {
            攻击: 600,
            特攻: 400,
            防御: 400,
            特防: 400,
            速度: 500,
            体力: 1050,
        },
        {
            criticalDamage: 0.30,
            fixedDamage: 0.35,
            percentDamage: 0.35,
        },
        [
            { state: "害怕", rate: 0.5 },
            { state: "麻痹", rate: 0.25 },
            { state: "睡眠", rate: 0.25 },
        ],
    ),
    new 布莱克(
        {
            攻击: 600,
            特攻: 400,
            防御: 400,
            特防: 400,
            速度: 500,
            体力: 1050,
        },
        {
            criticalDamage: 0.30,
            fixedDamage: 0.35,
            percentDamage: 0.35,
        },
        [
            { state: "害怕", rate: 0.5 },
            { state: "麻痹", rate: 0.25 },
            { state: "睡眠", rate: 0.25 },
        ],
    ),
];
